<template>
    <div>
        <el-form :rules="rules" ref="ruleForm" :model="editData" label-width="110px" size="mini">
            <el-form-item prop="name" class="lable-width" label="名称" :rules="{required: true, message: '请输入名称', trigger: 'blur'}">
                <el-input class="input-width" placeholder="请输入名称" clearable v-model="editData.name" :disabled="saveButton"></el-input>
            </el-form-item>
            <el-form-item prop="name" class="lable-width" label="物料" :rules="{required: true, message: '请输入物料', trigger: 'blur'}">
                <el-input class="input-width" placeholder="请输入物料" clearable v-model="editData.pzname" :disabled="saveButton"></el-input>
            </el-form-item>
            <el-form-item prop="pzId" class="lable-width" label="品种集合" >
                <el-select
                        size="mini"
                        style="margin-left: 0px;position: relative"
                        clearable class="input-width"
                        :filter-method="namesearch"
                        v-model="pzId"
                        @change="pzchange"
                        multiple
                        :reserve-keyword="true"

                        :disabled="saveButton"
                        filterable>
                    <el-option
                            v-for="item in pzdata"
                            :key="item.pzId"
                            :label="item.pzName"
                            :value="item.pzId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="pztypes" class="lable-width" label="单元集合" >
                <el-select
                        size="mini"
                        style="margin-left: 0px;position: relative"
                        clearable class="input-width"
                        :filter-method="dynamesearch"
                        @change="dychange"
                        v-model="typeid"
                        multiple
                        :reserve-keyword="true"
                        :disabled="saveButton"
                        filterable>
                    <el-option
                            v-for="item in dydata"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                            multiple
                            filterable>
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item prop="mj" class="lable-width" label="面积(m²)" >
                <el-input class="input-width" placeholder="请输入面积" clearable v-model="editData.mj" :disabled="saveButton"></el-input>
            </el-form-item>
            <el-form-item prop="rl" class="lable-width" label="容量(t)">
                <el-input class="input-width" placeholder="请输入容量" clearable v-model="editData.rl" :disabled="saveButton"></el-input>
            </el-form-item>

            <el-form-item prop="isbulkcargo" class="lable-width" label="是否散装" :rules="{required: true, message: '请选择是否散装', trigger: 'change'}">
                <div style="margin-left:20px; text-align: left;" >
                    <el-radio v-model="editData.isbulkcargo" :label="1" :disabled="saveButton">液态</el-radio>
                    <el-radio v-model="editData.isbulkcargo" :label="0" :disabled="saveButton">固态</el-radio>
                </div>
            </el-form-item>

            <el-form-item prop="state" class="lable-width" label="状态">
                <div style="margin-left:20px; text-align: left;">
                    <el-radio v-model="editData.state" :label="1" :disabled="saveButton">启用</el-radio>
                    <el-radio v-model="editData.state" :label="0" :disabled="saveButton">不启用</el-radio>
                </div>
            </el-form-item>
            <el-form-item prop="createTime" class="lable-width" label="录入时间">
                <el-input class="input-width"  disabled clearable v-model="editData.createTime"></el-input>
            </el-form-item>

            <el-form-item class="lable-width" style="margin-left: 0">
                <el-button style="margin-left: 0" type="primary" @click="onSubmit(editData)" :disabled="saveButton" >{{$t('button_save')}}</el-button>
                <el-button type="primary" @click="close">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import * as API from "../api";
    import {mapActions} from "vuex";

    export default {
        name: 'reviseTemplate',
        props:{
            getList:{
                type:Object
            },
            editData1:{
              type:Object
            },
            addData:{
                type:Object
            },
            listid:{
                type:Number
            },
            sonId:{
                type:Number
            },
            pzdata1:{
                type:Object
            },
            dydata1:{
                type:Object
            },
            title:{
                type:String
            },
        },
        data(){
            return{
                pzId:'',
                typeid:'',
                pzName:'',
                name:'',
                editData:this.editData1,
                pzdata:this.pzdata1,
                dydata:this.dydata1,
                addPzids:[],
                addTypeids:[],
                pztypedata:{},
                deletePzids:[],
                deleteTypeids:[],
                newrl:this.editData1.rl,
                value:'',
                oldrl:'',
                oldstate:0,
                furl:0,
                timeStamp:'',
                edit:0,
                saveButton:false,
                rules: {
                    name: [
                        { required: true, message: '请输入名称', trigger: 'blur' },
                    ],
                    pzname: [
                        { required: true, message: '请选择品种名称', trigger: 'blur' },
                    ],
                    mj: [
                        { required: true, message: '请输入面积', trigger: 'blur' },
                        {pattern: /^[0-9]+\.{0,1}[0-9]{0,15}$/, message: "请输入数字", trigger: "blur" },
                        {pattern: /^\d+(\.\d{1,5})?$/, message: "请保留五位小数", trigger: "blur" }
                    ],
                    rl: [
                        { required: true, message: '请输入容量', trigger: 'blur' },
                        {pattern: /^[0-9]+\.{0,1}[0-9]{0,15}$/, message: "请输入数字", trigger: "blur" },
                        {pattern: /^\d+(\.\d{1,5})?$/, message: "请保留五位小数", trigger: "blur" }
                    ]
                }
            }
        },
        watch:{
        },
        mounted(){
            if(this.title=='编辑品种'){
                this.saveButton=true
            }

            this.selectPztype()
            this.selectPz()


        },
        methods:{

            ...mapActions(["getCurrentMenuId"]),

            pzchange(val){
                let newArr=[]
                let Arr = val
                if(this.title=='编辑品种'){
                let oldArr=this.editData.pzids
                    if(!!oldArr){
                    newArr=  oldArr.filter(function (item,index) {
                    return oldArr.indexOf(item)===index
                });
                    }
                    this.addPzids= Arr.filter(item => !newArr.includes(item))
                }else {
                    this.addPzids=val
                }
                this.deletePzids= newArr.filter(item => !Arr.includes(item))
            },
            dychange(val1){
                let newArr=[]
                let Arr = val1
                if(this.title=='编辑品种'){
                    let oldArr=this.editData.typeids
                    if(!!oldArr){
                    newArr =  oldArr.filter(function (item,index) {
                    return oldArr.indexOf(item)===index
                });
                    }
                    this.addTypeids= Arr.filter(item => !newArr.includes(item))
                }else {
                    this.addTypeids=val1
                }
                    this.deleteTypeids= newArr.filter(item => !Arr.includes(item))

            },
            namesearch(val){
                this.pzName=val
                this.selectPz()
            },

            dynamesearch(val){
                this.name=val
                this.selectPztype()
            },

            close(){
                this.$emit('close')
            },
            refresh() {
                location.reload();
            },
            onSubmit(editData){
                this.savePm()
            },
            //单元下拉
            async selectPztype(val) {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id) {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }

                let params={
                    search:this.name,

                }

                let res = await API.selectPztype(params);
                if (res.code == 1) {
                    this.dydata = res.data


                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //品种下拉
            async selectPz(val) {

                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id) {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }

                let params={
                    search:this.pzName,

                }

                let res = await API.selectPz(params);
                if (res.code == 1) {
                    this.pzdata = res.data
                    if(this.title=='编辑品种'&&!this.name&&this.edit==0){
                        this.getPzDetails()
                    }
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            // 品种详情
            async getPzDetails() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }

                let params = {
                    id:this.sonId,

                }
                let res = await API.getPzDetails(params);
                if (res.code == 1) {
                    this.edit=1
                    this.editData=res.data
                    this.pzId=this.editData.pzids
                    this.typeid=this.editData.typeids
                    this.oldrl=JSON.parse(JSON.stringify(this.editData.rl))
                    this.oldstate=JSON.parse(JSON.stringify(this.editData.state))
                    this.saveButton = false
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },

            //品种保存
            async savePm(val) {
                if(!this.editData.name){
                        this.$message({
                            message: '请输入名称',
                            type: 'error'
                        });
                        return
                    }
                if(!this.editData.pzname){
                    this.$message({
                        message: '请输入物料名称',
                        type: 'error'
                    });
                    return
                }
                if(this.editData.mj===''){
                    this.$message({
                        message: '请输入面积',
                        type: 'error'
                    });
                    return
                }
                if(this.editData.mj<0){
                    this.$message({
                        message: '请输入大于0的面积',
                        type: 'error'
                    });
                    return
                }
                if(isNaN(this.editData.mj)){
                    this.$message({
                        message: '面积请输入数字',
                        type: 'error'
                    });
                    return
                }
                if(!this.editData.rl){
                    this.$message({
                        message: '请输入容量',
                        type: 'error'
                    });
                    return
                }
                if(this.editData.rl<=0){
                    this.$message({
                        message: '请输入大于0的容量',
                        type: 'error'
                    });
                    return
                }
                if(isNaN(this.editData.rl)){
                    this.$message({
                        message: '容量请输入数字',
                        type: 'error'
                    });
                    return
                }

                let params = {
                    id:this.editData.id,
                    name:this.editData.name,
                    addPzids:this.addPzids,
                    addTypeids:this.addTypeids,
                    deletePzids:this.deletePzids,
                    deleteTypeids:this.deleteTypeids,
                    oldrl:this.oldrl,
                    oldstate:this.oldstate,
                    pzname:this.editData.pzname,
                    mj:this.editData.mj,
                    rl:this.editData.rl,
                    isbulkcargo:this.editData.isbulkcargo,
                    wzid:this.listid,
                    state:this.editData.state,
                }
                this.saveButton=true
                // return
                let res = await API.savePm(params);
                if (res.code == 1) {

                    this.furl = res.kwTotalRl

                    this.saveButton=false
                    this.$emit('furl',this.furl)
                    this.$emit('getPzList',this.listid)

                    this.$emit("close")
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.saveButton=false
                    this.$message.error(res.message);
                }
            },


        }
    }
</script>
<style lang="scss" scoped>
    /deep/{
        .el-radio{
            margin: 0;
            margin-left: 30px;
        }
        .lable-width .el-form-item__content{
            margin-left: 0 !important;
        }
        .el-textarea__inner{
            height: 100px !important;
            color: #000000 !important;
            /*font-weight: 600 !important;*/
            font-size: inherit !important;
        }
        .el-form-item__error{
            left: 50% !important;
        }
    }
    .lable-width{
        text-align: center;
    }
    .slable-width{

    }
    .dialog-footer{
        display: flex;
        justify-content: center;
        align-items: center;
        /*text-align: center;*/
        margin-top: 12px;
    }
    .input-width{
        /*text-align: center;*/
        width: 18.571rem;
    }
    .sinput-width{
        width: 150px;
        margin-left: 28px;
    }
    /deep/.json .el-textarea__inner{
        height: 180px !important;
    }
    /deep/.describe .el-textarea__inner{
        height: 80px !important;

    }
</style>